export default {"src":"/_next/static/media/anything-else.10db3fbf.svg","height":29,"width":28,"blurWidth":0,"blurHeight":0};